import React, { useRef, useState } from "react";
import moment from "moment";
import Api from "../../../../../../adapters/api/api";
import Input from "../../../../../../components/Input";
import {
  Title,
  InputSize,
  Wrapper,
  InputLabel,
  InputRow,
  SaveButton,
} from "./style";
import { IServiceProviderProfile } from "../../../../../../interfaces/entities/IServiceProviderProfile";
import constants from "../../../../../../consts/conts";
import { useToast } from "../../../../../../hooks/Toast";

interface IUpdateProfile {
  document?: string;
  email?: string;
  password?: string;
  phone?: string;
  pagar_me_id?: string;
}

export const UpdateProvider: React.FC<{
  profile: IServiceProviderProfile | null;
}> = ({ profile }) => {
  const { addToast } = useToast();
  const [document, setDocument] = useState(
    profile?.id_service_provider_type_srcprf ===
      constants.service_provider_profile.legal_type
      ? profile.provider_legal?.cnpj_prvlgl || ""
      : profile?.provider_pearson?.cpf_prvprs || ""
  );

  const [email, setEmail] = useState(profile?.email_srcprf || "");
  const [phone, setPhone] = useState(
    profile?.provider_phone_number && profile.provider_phone_number.length > 0
      ? profile.provider_phone_number[0].formated_number_prvphnbr
      : ""
  );
  const [password, setPassword] = useState("");
  const [pagar_me_id, set_pagar_me_id] = useState(profile?.pagarme_id_srcprf);

  if (!profile) {
    return null;
  }

  const updateProfile = async (data: IUpdateProfile) => {
    try {
      const profileReponse = await Api.put(`/admin/user/profile`, {
        ...data,
        service_provider_profile_id: profile.id_srcprf,
      });
      addToast({
        title: "Atualização realizada",
        description: "Os dados foram atualizados com sucesso.",
        type: "success",
      });
    } catch (err: any) {
      const responseData = err.response?.data;

      if ([422].includes(err.response?.status) && responseData?.data) {
        const message = Object.entries(responseData.data)
          .map(([field, error]) => `${field} - ${error}`)
          .join(", ");

        addToast({
          title: responseData.message || "Parâmetros inválidos",
          description: message,
          type: "error",
        });
      } else if (
        [422, 400, 401, 404].includes(err.response?.status) &&
        responseData?.message
      ) {
        addToast({
          title: "Erro ao atualizar Perfil",
          description: responseData.message,
          type: "error",
        });
      } else {
        addToast({
          title: "Erro ao buscar usuários",
          description:
            "Ocorreu um erro inesperado ao processar sua requisição. Tente novamente mais tarde.",
          type: "error",
        });
      }
    }
  };

  const updateEmail = async () => {
    const confirmed = window.confirm(
      `Tem certeza que deseja alterar o email para ${email}?`
    );
    if (!confirmed) return;
    await updateProfile({ email });
  };

  const updatePhone = async () => {
    const confirmed = window.confirm(
      `Tem certeza que deseja alterar o celular para ${phone}?`
    );
    if (!confirmed) return;
    await updateProfile({ phone });
  };

  const updateDocument = async () => {
    const confirmed = window.confirm(
      `Tem certeza que deseja alterar o documento para ${document}?`
    );
    if (!confirmed) return;

    await updateProfile({ document });
  };

  const update_pagar_me_id = async () => {
    const confirmed = window.confirm(
      `Tem certeza que deseja alterar o id pargarme \n ${profile.pagarme_id_srcprf} PARA ${pagar_me_id} ?`
    );
    if (!confirmed) return;

    await updateProfile({ pagar_me_id });
  };

  const update_password = async () => {
    const confirmed = window.confirm(
      `Tem certeza que deseja alterar a senha para ${password}?`
    );
    if (!confirmed) return;

    await updateProfile({ password });
  };

  return (
    <>
      <Title>Perfil</Title>
      <hr />
      <Wrapper>
        <InputLabel>Documento</InputLabel>
        <InputRow>
          <InputSize>
            <Input
              name="document"
              placeholder="Documento"
              onChange={(e) => setDocument(e.target.value)}
              value={document}
            />
          </InputSize>

          <SaveButton
            onClick={() => {
              updateDocument();
            }}
          >
            Alterar
          </SaveButton>
        </InputRow>
      </Wrapper>

      <Wrapper>
        <InputLabel>Email</InputLabel>
        <InputRow>
          <InputSize>
            <Input
              name="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </InputSize>

          <SaveButton
            onClick={() => {
              updateEmail();
            }}
          >
            Alterar
          </SaveButton>
        </InputRow>
      </Wrapper>

      <Wrapper>
        <InputLabel>Celular</InputLabel>
        <InputRow>
          <InputSize>
            <Input
              name="phone"
              placeholder="celular"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
          </InputSize>

          <SaveButton
            onClick={() => {
              updatePhone();
            }}
          >
            Alterar
          </SaveButton>
        </InputRow>
      </Wrapper>

      <hr />
      <Wrapper>
        <InputLabel>Senha</InputLabel>
        <InputRow>
          <InputSize>
            <Input
              name="password"
              placeholder="Senha"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </InputSize>

          <SaveButton
            onClick={() => {
              update_password();
            }}
          >
            Alterar
          </SaveButton>
        </InputRow>
      </Wrapper>

      <hr />
      <Wrapper>
        <InputLabel>Pagar Me</InputLabel>
        <InputRow>
          <InputSize>
            <Input
              name="pagarme_id"
              placeholder="Pagarme ID"
              value={pagar_me_id}
              onChange={(e) => set_pagar_me_id(e.target.value)}
            />
          </InputSize>

          <SaveButton
            onClick={() => {
              update_pagar_me_id();
            }}
          >
            Alterar
          </SaveButton>
        </InputRow>
      </Wrapper>
    </>
  );
};
